<template>
  <v-template>
    <v-btn
      tile
      elevation="0"
      color="primary"
      @click.stop="drawer = !drawer"
      class="menuBtn"
    >
      <v-icon>mdi-menu</v-icon>
    </v-btn>
    <v-navigation-drawer v-model="drawer" fixed right temporary width="400">
      <v-list nav class="pa-0 mt-8">
        <v-list-item class="d-flex align-center">
            <h3 class="mb-0 ml-6">Pages</h3>
            <v-btn
              @click.stop="drawer = !drawer"
              icon color="primary"
              style="margin-left:auto"
              class="ml-auto mr-6"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-list-item>
        <v-list-item-group>
          <v-list-item
            v-for="item in menuItems"
            :key="item.id"
            @click="openPage(getPage(item).route)"
            class="b-b mb-0 pl-8"
          >
            {{ getPage(item).navTitle }}
          </v-list-item>
          <v-list-item
            href="https://workinfinland.com"
            target="_blank"
            class="b-b mb-0 pl-8"
          >
            Get to know Finland
            <v-icon class="ml-auto mr-4">
              mdi-open-in-new
            </v-icon>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-list-item
            href="/admin"
            target="_blank"
            class="mb-0 pl-8 text-overline"
            slot="append"
          >
            <v-icon small class="mr-4">
                mdi-lock
            </v-icon>
            <small>Jobster login</small>
          </v-list-item>
    </v-navigation-drawer>
  </v-template>
</template>
<script>
export default {
  data: () => ({
    drawer: false,
    /* Fallback to the following navTitles if no content page is found */
    menuItems: [
      {
        id: '',
        navTitle: 'Open positions',
        route: '/',
      },
      {
        id: 'about',
        navTitle: 'About',
        route: '/about',
      },
      {
        id: 'for-employers',
        navTitle: 'For employers',
        route: '/for-employers',
      },
      {
        id: 'privacy',
        navTitle: 'Privacy policy',
        route: '/privacy',
      },
      {
        id: 'terms',
        navTitle: 'Terms of service',
        route: '/terms',
      },
    ],
  }),
  mounted() {
    if (this.$store.state.pages.length === 0) {
      this.$store.dispatch('dispatchGetPages');
    }
  },
  methods: {
    openPage(route) {
      // When navigating to or from admin, the page should hard refresh
      // in order for the GTM analytics scripts to be reloaded.

      const fromBase = this.$route.path.split('/')[1];
      const toBase = route.split('/')[1];

      if (
        (toBase !== fromBase)
        && (toBase === 'admin' || fromBase === 'admin')
      ) {
        window.location.replace(route);
      } else {
        this.$router.push(route);
      }
    },
    getPage(menuItem) {
      const page = this.$store.state.pages.find(p => p.id === menuItem.id);
      if (page !== undefined) {
        page.route = page.navTitle.toLowerCase().replaceAll(' ', '-');
        return page;
      }

      return menuItem;
    },
  },
};
</script>
<style>
h3{
    color: #002ea1;
    margin: 0;
}
.v-list-item {
  text-transform: uppercase;
  font-size: 18px;
}
.menuBtn{
  position: absolute;
  top:0;
  right:0;
  min-height: 86px;
  width: 86px;
  display: block;
  z-index: 1;
}
@media screen and (max-width: 600px) {
  .menuBtn{
    min-height: 75px;
    width: 75px;
  }
}
</style>
